import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";


/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default{

    props: ['show', 'item'],

    data() {
        return {
            locale: LocService,
            title: '',
            subTitle: '',
            id: 0,
            hasError: null,
            isLoading: false,
            profitRsd: 0,
            profitEur: 0,
            moneyEur: 0,
            moneyRsd: 0,
            comment: '',
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                //TODO
                console.log(this.item)
                let item = this.item;
                this.id = item.id;
                this.profitRsd = item.profitRsd;
                this.profitEur = item.profitEur;
                this.moneyEur = item.moneyEur;
                this.moneyRsd = item.moneyRsd;
            }
        },
        amount: function(val, oldVal) {
            this.hasError = '';
        },
    },


    methods: {
        close() {
            this.$topnavbar.$emit('closeEditScheduleItem')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successEditScheduleItem')
        },
        onTabClicked: onTabClicked,
        reset: reset,
        closeSchedule: closeSchedule,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--large'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        },
    }
}

function onTabClicked(tab){
    this.selectedButton = tab;
}

function reset() {
   this.profitEur = 0;
   this.profitRsd = 0;
}

function closeSchedule(){
    let _self = this;
    
        let request = {
            id: _self.id,
            moneyRsdIn: _self.moneyRsd,
            moneyEurIn: _self.moneyEur,
            profitRsd: _self.profitRsd,
            profitEur: _self.profitEur,
        }
    
        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {
        });
    
        AdminApiService.editScheduleItem(request)
            .then((response) => {
                _self.reset()
                _self.successUpdate();
                swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
            
            })
            .catch((error) => {
                _self.isLoading = false;
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
}





// WEBPACK FOOTER //
// ./src/modals/ChangeScheduleItem.js